export const DEV = process.env.NODE_ENV === "development";
export const apiUrl = process.env.GATSBY_API_URL;
export const pdfApiUrl = process.env.GATSBY_PDF_API;
export const dateFormat = "DD/MM/YYYY";
export const dateTimeFormat = "DD/MM/YYYY hh:mm a";
export const fbAppId = "1065509547136289";
